export const environment = {
  production: false,
  URL_SERVICIOS_GENESYS: 'https://api.mypurecloud.com/api/v2',
  ENVIRONMENT: 'mypurecloud.com',
  CLIENT_ID_GENESYS: 'dcad421d-a08c-4fff-b466-0b95fcbd7ec1',
  LAMBDA_URL: 'https://vkfpr9j83m.execute-api.us-east-1.amazonaws.com/v1',
};

